import get from 'lodash/get';
import { parse } from 'node-html-parser';
import { richTextEditorPlaceholdersByTemplate } from '@nsr/applicant-apply-shared/src/constants/placeholders';

const getDAValueFromEedmModel = async (formValues, template, eedmDestinationModel, eedmDestinationAttribute, supportedGraphqlModels, api) => {
    const questionPath = findQuestionFromEedmAttribute(template, eedmDestinationModel, eedmDestinationAttribute);
    if(questionPath){
        let ids = get(formValues, questionPath.path);
        if (!Array.isArray(ids)) {
            ids = [ids];
        }
        const model = questionPath.question.possibleValues.model;
        const modelAttribute = questionPath.question.possibleValues.modelAttribute;
        const graphType = supportedGraphqlModels[model].graphType;
        const result = await api.dataAccess.getValuesByIds(graphType, ids, modelAttribute);
        return { ...result, modelAttribute };
    }
    return false;
};



export const findQuestionFromEedmAttribute = (template, eedmDestinationModel, eedmDestinationAttribute) => {
    const { pages = [] } = template;
    for (let pageIdx = 0; pageIdx < pages.length; pageIdx++) {
        const { sections = [] } = pages[pageIdx];
        for (let sectionIdx = 0; sectionIdx < sections.length; sectionIdx++) {
            const { groups = [], showRepetition } = sections[sectionIdx];
            for (let groupIdx = 0; groupIdx < groups.length; groupIdx++) {
                const { questions = [] } = groups[groupIdx];
                for (let questionIdx = 0; questionIdx < questions.length; questionIdx++) {
                    if (questions[questionIdx].eedmDestinationModel === eedmDestinationModel &&
                        questions[questionIdx].eedmDestinationAttribute === eedmDestinationAttribute) {
                        return {
                            path: showRepetition ? `${pages[pageIdx].id}.${sections[sectionIdx].id}.0.${questions[questionIdx].id}` : `${pages[pageIdx].id}.${questions[questionIdx].id}`,
                            question: questions[questionIdx]
                        };
                    }
                }
            }
        }
    }
    return undefined;
};

const replaceInnerTextWithValue = (html, value) => {
    html.removeAttribute('data-id');
    html.removeAttribute('data-label');
    let iter = html;
    while (iter.childNodes.some(x => x.nodeType === 1) /* HTML element */) {
        iter = iter.childNodes.find(x => x.nodeType === 1);
    }
    iter.textContent = value;
};

export const replacePlaceholders = async (htmlString, values, template, type, supportedGraphqlModels, api) => {
    if (!htmlString || !values || !template?.pages || !type) {
        return '';
    }
    const html = parse(htmlString);
    //If not template type like apply-prospect, so we fallback to model
    let model = Object.keys(richTextEditorPlaceholdersByTemplate).find(key => richTextEditorPlaceholdersByTemplate[key].some(obj => obj.model === type));
    const types = richTextEditorPlaceholdersByTemplate[template?.templateType || model];
    const placeholders = html.querySelectorAll('[data-id]');
    for (const placeholder of placeholders) {
        const pHolderKey = types.find(x => x.id === placeholder.getAttribute('data-id'));
        let pHolderVal;
        if (pHolderKey?.isDA) {
            try {
                const daResult = await getDAValueFromEedmModel(values, template, pHolderKey.model, pHolderKey.attribute, supportedGraphqlModels, api);
                if (daResult && daResult.list && daResult.list.length > 0) {
                    const daValue = daResult.list.map(value => value[daResult.modelAttribute]);
                    pHolderVal = daValue.join(', ');
                }
                else {
                    pHolderVal = '';
                }
            }
            catch (e) {
                console.error('DataAccess error', e);
                pHolderVal = '';
            }
        }
        else {
            const valPath = pHolderKey ? findQuestionFromEedmAttribute(template, pHolderKey.model, pHolderKey.attribute)?.path : '';
            pHolderVal = valPath ? get(values, valPath, '') : '';
            if (Array.isArray(pHolderVal)) {
                pHolderVal = pHolderVal.length > 0 ? pHolderVal[0] : '';
            }
            if (pHolderKey && pHolderKey.id === 'phone-number') {
                pHolderVal = `+${pHolderVal.code}${pHolderVal.number}`;
            }
        }
        if (placeholder.getAttribute('data-id') === 'preferred-first-name') {
            const pHolderAlternatives = ['preferred-name', 'first-name'];
            for (const alternative of pHolderAlternatives) {
                if (!pHolderVal){
                    const pHolderKey = types.find(x => x.id === alternative);
                    const valPath = pHolderKey ? findQuestionFromEedmAttribute(template, pHolderKey.model, pHolderKey.attribute)?.path : '';
                    pHolderVal = valPath ? get(values, valPath, '') : '';
                }
            }
        }
        replaceInnerTextWithValue(placeholder, pHolderVal);
    }
    return html.toString();
};

export const replaceGenericPlaceholder = (htmlString, key, value) => {
    if (!htmlString || !key || !value) {
        return '';
    }
    const html = parse(htmlString);
    const placeholders = html.querySelectorAll(`[data-id=${key}]`);
    for (const placeholder of placeholders) {
        replaceInnerTextWithValue(placeholder, value);
    }
    return html.toString();
};
